import React from "react"
import I18n from 'i18n-js';
import '../translations.js';

export class NewEsmAccountTips extends React.Component {

  render () {
    return (
      <div className="hero-unit">
        <div className="alert alert-danger" dangerouslySetInnerHTML={{ __html: I18n.t("exhibitor.warning_create_one_account") }}></div>
        <h3>{ I18n.t("exhibitor.how_do_create_account_header") }</h3>
        <ol>
          <li>{ I18n.t("exhibitor.tip_1") }
            <br/>
            <br/>
          </li>
          <li>{ I18n.t("exhibitor.tip_2") }
            <br/>
            <br/>
          </li>
          <li>{ I18n.t("exhibitor.tip_2") }
          </li>
        </ol>
      </div>
    );
  }
}
